/** Turns a sample JSON payload into a flat list of JSONPath-style field references someone can
 *  map to a template variable. Handles a plain object, nested objects, or a top-level array. For
 *  an array, this returns BOTH the array's own path (map the whole list to a variable to loop
 *  over it with {{#each yourVariable}} in the template) AND scalar leaf paths sampled from its
 *  first item (map one field from one record) - a report needing a repeating table needs the
 *  former, not the latter, and previously only the latter was ever discoverable. */
export function flattenSample(obj: unknown, prefix = "$"): string[] {
  if (obj === null || typeof obj !== "object") return [prefix];
  const out: string[] = [];
  if (Array.isArray(obj)) {
    if (obj.length > 0) {
      out.push(prefix);
      out.push(...flattenSample(obj[0], `${prefix}[0]`));
    }
    return out;
  }
  for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
    const path = `${prefix}.${key}`;
    if (value !== null && typeof value === "object") {
      out.push(...flattenSample(value, path));
    } else {
      out.push(path);
    }
  }
  return out;
}
